import { lazyLoad } from 'utils/loadable';

export const CreateOrderProductsListPage = lazyLoad(
    () => import('./index'),
    module => module.CreateOrderProductsListPage,
);
